import $ from "jquery";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import API_BASE_URL from "../../../helper.js";

// Function to show success modal
function showSuccessModal(message) {
    $("#successMessage").text(message);
    const modal = new window.bootstrap.Modal(document.getElementById("successModal"));
    modal.show();
}

// ✅ MOVE OUTSIDE (ONLY CHANGE)
function loadAllTeams() {
    $.ajax({
        url: `${API_BASE_URL}/api/team/all`,
        type: "GET",
        success: function (teams) {

            teams.reverse();
            let rows = "";
            teams.reverse().forEach((t, i) => {
                rows += `
                    <tr>
                        <td>${i + 1}</td>
                        <td><img src="${API_BASE_URL}/assets/Images/${t.image}" width="80" /></td>
                        <td>${t.name}</td>
                        <td>${t.position}</td>
                        <td>
                            <button class="btn btn-primary btn-sm editTeamBtn" data-id="${t.id}">Edit</button>
                            <button class="btn btn-danger btn-sm deleteTeam" data-id="${t.id}">Delete</button>
                        </td>
                    </tr>
                `;
            });

            $("#allTeamData").html(rows);
        },
        error: function (err) {
            console.error(err);
        }
    });
}

// ✅ KEEP SAME
window.loadTeams = function () {
    loadAllTeams();
};

$(document).ready(function () {

    // ADD Team
    $("#addTeamForm").submit(function (e) {
        e.preventDefault();

        const formData = new FormData();
        formData.append("name", $("#name").val());
        formData.append("position", $("#position").val());
        formData.append("image", $("#image")[0].files[0]);

        $.ajax({
            url: `${API_BASE_URL}/api/team/add`,
            type: "POST",
            data: formData,
            contentType: false,
            processData: false,
            success: function () {
                showSuccessModal("Team Added Successfully!");
                $("#addTeamForm")[0].reset();

                const modal = window.bootstrap.Modal.getInstance(document.getElementById("teamModal"));
                modal.hide();
                loadAllTeams();
            },
            error: function (err) {
                console.error(err);
                alert("Failed to add Team!");
            }
        });
    });

    // OPEN EDIT MODAL
    $(document).on("click", ".editTeamBtn", function () {
        const id = $(this).data("id");

        $.ajax({
            url: `${API_BASE_URL}/api/team/get/${id}`,
            type: "GET",
            success: function (t) {

                $("#editId").val(t.id);
                $("#editName").val(t.name);
                $("#editPosition").val(t.position);

                new window.bootstrap.Modal(document.getElementById("editTeamModal")).show();
            },
            error: () => alert("Failed to fetch team member data")
        });
    });

    // UPDATE TEAM
    $("#editTeamForm").submit(function (e) {
        e.preventDefault();

        const id = $("#editId").val();
        const formData = new FormData();

        formData.append("name", $("#editName").val());
        formData.append("position", $("#editPosition").val());

        if ($("#editImage")[0].files.length > 0) {
            formData.append("image", $("#editImage")[0].files[0]);
        }

        $.ajax({
            url: `${API_BASE_URL}/api/team/update/${id}`,
            type: "POST",
            contentType: false,
            processData: false,
            data: formData,
            success: function () {
                showSuccessModal("Team Member Updated Successfully!");
                loadAllTeams();
                window.bootstrap.Modal.getInstance(document.getElementById("editTeamModal")).hide();
            },
            error: () => alert("Failed to update Team Member")
        });
    });

    // DELETE Team
    $(document).on("click", ".deleteTeam", function () {
        let id = $(this).data("id");

        if (!window.confirm("Are you sure want to delete this Team Member?")) return;

        $.ajax({
            url: `${API_BASE_URL}/api/team/delete/${id}`,
            type: "DELETE",
            success: function () {
                showSuccessModal("Team Member Deleted Successfully!");
                loadAllTeams();
            },
            error: function (err) {
                console.error(err);
                alert("Failed to delete Team Member!");
            }
        });
    });

});

// import $ from "jquery";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import API_BASE_URL from "../../../helper.js";

// // Function to show success modal
// function showSuccessModal(message) {
//     $("#successMessage").text(message);
//     const modal = new window.bootstrap.Modal(document.getElementById("successModal"));
//     modal.show();
// }

// window.loadTeams = function () {
//     loadAllTeams();
// };

// $(document).ready(function () {

//     // ADD Team
//     $("#addTeamForm").submit(function (e) {
//         e.preventDefault();

//         const formData = new FormData();
//         formData.append("name", $("#name").val());
//         formData.append("position", $("#position").val());
//         formData.append("image", $("#image")[0].files[0]);

//         $.ajax({
//             url: `${API_BASE_URL}/api/team/add`,
//             type: "POST",
//             data: formData,
//             contentType: false,
//             processData: false,
//             success: function () {
//                 showSuccessModal("Team Added Successfully!");
//                 $("#addTeamForm")[0].reset();

//                 const modal = window.bootstrap.Modal.getInstance(document.getElementById("teamModal"));
//                 modal.hide();
//                 loadAllTeams();
//             },
//             error: function (err) {
//                 console.error(err);
//                 alert("Failed to add Team!");
//             }
//         });
//     });

//     // LOAD ALL Team DATA
//     function loadAllTeams() {
//         $.ajax({
//             url: `${API_BASE_URL}/api/team/all`,
//             type: "GET",
//             success: function (teams) {

//                 teams.reverse();
//                 let rows = "";
//                 teams.reverse().forEach((t, i) => {
//                     rows += `
//                         <tr>
//                             <td>${i + 1}</td>
//                             <td><img src="${API_BASE_URL}/assets/Images/${t.image}" width="80" /></td>
//                             <td>${t.name}</td>
//                             <td>${t.position}</td>
//                             <td>
//                                 <button class="btn btn-primary btn-sm editTeamBtn" data-id="${t.id}">Edit</button>
//                                 <button class="btn btn-danger btn-sm deleteTeam" data-id="${t.id}">Delete</button>
//                             </td>
//                         </tr>
//                     `;
//                 });

//                 $("#allTeamData").html(rows);
//             },
//             error: function (err) {
//                 console.error(err);
//             }
//         });
//     }

//     // OPEN EDIT MODAL
//     $(document).on("click", ".editTeamBtn", function () {
//         const id = $(this).data("id");

//         $.ajax({
//             url: `${API_BASE_URL}/api/team/get/${id}`,
//             type: "GET",
//             success: function (t) {

//                 $("#editId").val(t.id);
//                 $("#editName").val(t.name);
//                 $("#editPosition").val(t.position);

//                 new window.bootstrap.Modal(document.getElementById("editTeamModal")).show();
//             },
//             error: () => alert("Failed to fetch team member data")
//         });
//     });

//     // // UPDATE TEAM
//     $("#editTeamForm").submit(function (e) {
//         e.preventDefault();

//         const id = $("#editId").val();
//         const formData = new FormData();

//         formData.append("name", $("#editName").val());
//         formData.append("position", $("#editPosition").val());

//         if ($("#editImage")[0].files.length > 0) {
//             formData.append("image", $("#editImage")[0].files[0]);
//         }

//         $.ajax({
//             url: `${API_BASE_URL}/api/team/update/${id}`,
//             type: "POST",
//             contentType: false,
//             processData: false,
//             data: formData,
//             success: function () {
//                 showSuccessModal("Team Member Updated Successfully!");
//                 loadAllTeams();
//                 window.bootstrap.Modal.getInstance(document.getElementById("editTeamModal")).hide();
//             },
//             error: () => alert("Failed to update Team Member")
//         });
//     });

//     // DELETE Team
//     $(document).on("click", ".deleteTeam", function () {
//         let id = $(this).data("id");

//         if (!window.confirm("Are you sure want to delete this Team Member?")) return;

//         $.ajax({
//             url: `${API_BASE_URL}/api/team/delete/${id}`,
//             type: "DELETE",
//             success: function () {
//                 showSuccessModal("Team Member Deleted Successfully!");
//                 loadAllTeams();
//             },
//             error: function (err) {
//                 console.error(err);
//                 alert("Failed to delete Team Member!");
//             }
//         });
//     });

// });

